'use client';

import { ReactNode } from 'react';
import BaseNav from '~/components/Chrome/Header/Mobile/BaseNav';
import { MobileNavOverlay } from '~/components/Chrome/Header/Mobile/MobileNavElements';
import { useMobileNav } from '~/contexts/MobileNavContext';

export default function AppDirMobileNavOverlay({
  children,
}: {
  children: ReactNode;
}) {
  const { isOpen, toggleNav } = useMobileNav();

  return (
    <>
      <BaseNav
        style={{
          margin: 0,
          left: isOpen ? 0 : -270,
        }}
      >
        {children}
      </BaseNav>

      {isOpen && (
        <MobileNavOverlay
          style={{
            left: isOpen ? 270 : undefined,
          }}
          onClick={toggleNav}
        />
      )}
    </>
  );
}
